import type { BookingStatus } from '@/enums/booking'

export interface IPublicService {
    id:               string
    name:             string
    description:      string
    duration_minutes: number
    price:            number
}

export interface IPublicFacility {
    id:          string
    name:        string
    description: string
    services:    IPublicService[]
    /** Photos, cover first. */
    image_ids?:  string[]
}

export interface IPublicTenant {
    name:               string
    slug:               string
    description:        string
    contact_email:      string
    contact_phone:      string
    address:            string
    timezone:           string
    min_notice_minutes: number
    max_days_ahead:     number
    facilities:         IPublicFacility[]
    /** The tenant's logo, "" when none. */
    logo_image_id?:     string
}

/** A tenant image's bytes, served publicly under the tenant's slug. */
export const publicImageUrl = (slug: string, id: string): string =>
    `/api/rezervacije_external/v1/${encodeURIComponent(slug)}/images/${id}`

export interface IPublicStart {
    start: string
    end:   string
}

export interface IPublicBooking {
    code:          string
    tenant_name:   string
    facility_name: string
    service_name:  string
    start_at:      string
    end_at:        string
    status:        BookingStatus
    customer_name: string
    amount:        number
    can_cancel:    boolean
    /** The code that opens the gates; present only while the booking is booked. */
    access:        IPublicAccess | null
}

export interface IPublicAccess {
    code:        string
    valid_from:  string
    valid_until: string
}

export interface IPublicBookingRequest {
    service_id: string
    start:      string
    customer:   {
        name:  string
        email: string
        phone: string
    }
    notes:      string
    /** Consent to news and offers by e-mail — never pre-ticked. */
    marketing_consent: boolean
}

export interface IPublicBookingResponse {
    code:    string
    token:   string
    booking: IPublicBooking
}
